<!-- 郵便番号入力コンポーネント -->
<template>
    <div>
        <dd class="zipcode" :class="klass">
            <template v-if="validate.$error">
                <span class="errNote">郵便番号（半角数字7桁）を入力してください。</span>
            </template>
            <input v-model="validate.$model"
                   @input="toHalfWidth"
                   type="text"
                   id="js-input-zip"
                   class="regular"
                   maxlength="7"
                   placeholder="1000001">
        </dd>
        <span class="annotation" style="margin-top: 6px">郵便番号を入力すると、住所の一部が自動的に入力されます。</span>
    </div>
</template>


<script>
export default {
    name: "UserInfoPostcodeField",
    props: {
        validate: {
            type: Object,
            required: true
        }
    },
    computed: {
        klass: function(){
            return { error: this.validate.$error };
        }
    },
    methods: {
        toHalfWidth: function(){
            // 全角数字を半角に変換
            this.validate.$model = this.validate.$model.replace(/[０-９]/g, function(str){
                return String.fromCharCode(str.charCodeAt(0) - 65248);
            });
        }
    }
}
</script>
